var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 px-5"},_vm._l((_vm.items),function(item){return _c('creator-by-talent-rep-item',{key:item.userId,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }